import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBell"><Path d="M12 2C7.79219 2 4.26146 5.17264 3.81319 9.35647L3 17.5H21L20.1867 9.35648C19.7385 5.17264 16.2077 2 12 2Z" fill="currentColor"/><Path d="M16.5839 19H7.41601C8.18757 20.7659 9.94965 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell;
